/* NW sengeguide: maaling. Tilfoejet 28-08-2026.
   Sender events til GA4 via gtag og til Shopify web pixels via Shopify.analytics.publish.
   En custom pixel i Shopify admin videresender til Meta.

   VIGTIGT OM SAMTYKKE: gtag naar foerst GA4 naar brugeren har accepteret cookies,
   og Shopify.analytics.publish er ligeledes samtykke-styret. Guidens eget Klaviyo-kald
   (sendLead i page.find-dit-sengetoj.liquid) fyrer derimod uanset samtykke og er
   derfor det mest komplette tal for leads. Forvent at GA4 undertaeller kraftigt.

   VIGTIGT OM SCOPE: guidens answers/chosen/materials er top-level let/const i
   nw-sg-*.js og ligger derfor i det delte script-scope, IKKE paa window.
   De skal tilgaas som bare navne inde i try/catch. window.answers er undefined.

   Filen aendrer ikke guidens logik. Den wrapper globale funktioner og lytter paa DOM. */
(function(){
  'use strict';

  var sendt = {};
  var hooked = {};
  var koersler = 0;

  function ga(navn, data){
    try{ if(typeof window.gtag === 'function'){ window.gtag('event', navn, data); } }catch(e){}
  }

  function pixel(navn, data){
    try{
      if(window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function'){
        window.Shopify.analytics.publish(navn, data);
      }
    }catch(e){}
  }

  function spor(navn, data){
    data = data || {};
    ga(navn, data);
    pixel(navn, data);
    if(window.NW_TRACK_DEBUG){ try{ console.log('[nw-sg-track]', navn, data); }catch(e){} }
  }

  function enGang(noegle, navn, data){
    if(sendt[noegle]){ return; }
    sendt[noegle] = true;
    spor(navn, data);
  }

  function svar(){
    var d = {
      sovere: '', koen: '', alder: '', behov: '', antal_behov: 0,
      fornemmelse: '', farvetone: '', stoerrelse_sengetoej: '', stoerrelse_seng: ''
    };
    try{
      var a = answers || {};
      var c = a.challenges || [];
      d.sovere = a.sleepers || '';
      d.koen = a.gender || '';
      d.alder = a.age || '';
      d.behov = c.length ? c.slice(0).sort().join(',') : '';
      d.antal_behov = c.length;
      d.fornemmelse = a.feel || '';
      d.farvetone = a.tone || '';
      d.stoerrelse_sengetoej = a.size || '';
      d.stoerrelse_seng = a.bed || '';
    }catch(e){}
    return d;
  }

  function total(){
    try{
      var el = document.getElementById('bartotal');
      if(!el){ return 0; }
      var t = String(el.textContent).replace(/\./g, '').replace(/,/g, '.');
      return Number(t.replace(/[^0-9.]/g, '')) || 0;
    }catch(e){ return 0; }
  }

  function anbefaling(){
    var d = svar();
    d.value = total();
    d.currency = 'DKK';
    try{
      var m = materials[chosen.mat];
      d.materiale = chosen.mat;
      d.materiale_navn = m.name;
      d.farve = m.colors[chosen.color].name;
      d.stoerrelse = chosen.size;
      d.antal = chosen.qty || 1;
    }catch(e){}
    try{
      d.lagen = !!(chosen.lagen && chosen.lagen.on);
      d.pude_antal = (chosen.pude && chosen.pude.qty) || 0;
      d.pudebetraek_antal = (chosen.pb && chosen.pb.qty) || 0;
      d.vaskemiddel = !!(chosen.simple && chosen.simple.vaskemiddel);
      d.vaskepose = !!(chosen.simple && chosen.simple.vaskepose);
    }catch(e){}
    return d;
  }

  function gyldigMail(v){
    return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(v || '').trim());
  }

  /* Wrapper en global funktion. Kun een gang pr. sidevisning, uanset hvor mange
     gange kobl() koeres. Guidens egen wire() wrapper efterfoelgende udenom vores,
     hvilket er uskadeligt: vores kald sker stadig.
     foer koeres inden originalen, efter koeres bagefter. */
  function wrap(navn, foer, efter){
    if(hooked[navn]){ return false; }
    var f = window[navn];
    if(typeof f !== 'function'){ return false; }
    hooked[navn] = true;
    window[navn] = function(){
      if(foer){ try{ foer.apply(this, arguments); }catch(e){} }
      var r = f.apply(this, arguments);
      if(efter){ try{ efter.apply(this, arguments); }catch(e){} }
      return r;
    };
    return true;
  }

  /* Nulstilling og start skal ske FOER originalen, ellers rydder vi den
     dedupe-noegle som trin 1 lige har sat, og trin 1 kan taelles to gange. */
  function hookStart(){
    wrap('resetQuiz', function(){
      koersler++;
      sendt = {};
      spor('nw_guide_start', { omtagning: koersler > 1 });
    }, null);
  }

  function hookTrin(){
    wrap('renderQ', null, function(){
      var n = 0;
      try{ n = parseInt(document.getElementById('qnow').textContent, 10) || 0; }catch(e){}
      if(!n){ return; }
      enGang('trin' + n, 'nw_guide_trin', { trin: n });
    });
  }

  function hookResultat(){
    wrap('renderResult', null, function(){
      enGang('complete', 'nw_guide_complete', anbefaling());
    });
  }

  function hookLead(){
    if(hooked.lead){ return; }
    hooked.lead = true;
    document.addEventListener('click', function(ev){
      var t = ev.target;
      if(!t || !t.className){ return; }
      var k = String(t.className);
      if(k.indexOf('nw-em-send') < 0 || k.indexOf('nw-em-okclose') >= 0){ return; }
      var inp = document.querySelector('#nw-email-modal .nw-em-input');
      if(!inp || !gyldigMail(inp.value)){ return; }
      var d = anbefaling();
      var box = document.querySelector('#nw-email-modal .nw-em-consent');
      d.nyhedsbrev = !!(box && box.checked);
      spor('nw_guide_lead', d);
    }, true);
  }

  function hookKurv(){
    if(hooked.kurv){ return; }
    var md = document.getElementById('nw-added-modal');
    if(!md){ return; }
    hooked.kurv = true;
    try{
      new MutationObserver(function(){
        if(md.classList.contains('open')){
          spor('nw_guide_add_to_cart', anbefaling());
        }
      }).observe(md, { attributes: true, attributeFilter: ['class'] });
    }catch(e){}
  }

  function kobl(){
    hookStart();
    hookTrin();
    hookResultat();
    hookLead();
    hookKurv();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', kobl);
  } else {
    kobl();
  }
  window.addEventListener('load', kobl);
  setTimeout(kobl, 2000);
  setTimeout(kobl, 4000);
})();